import { render, staticRenderFns } from "./MultipleText.vue?vue&type=template&id=607a67bc&scoped=true&"
import script from "./MultipleText.vue?vue&type=script&lang=js&"
export * from "./MultipleText.vue?vue&type=script&lang=js&"
import style0 from "./MultipleText.vue?vue&type=style&index=0&id=607a67bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../Breeze.Portal.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607a67bc",
  null
  
)

export default component.exports